module.exports = __webpack_public_path__ + "img/sinImagenSinapsis.5d733b8f.jpg";